export const MonthYearDropdown = ({ date, onMonthChange, locale = "en" }) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear - 100; y <= currentYear + 5; y++) {
    years.push(y);
  }
  const months = Array.from({ length: 12 }, (_, i) =>
    new Intl.DateTimeFormat(locale, { month: "long" }).format(
      new Date(2000, i, 1),
    ),
  );

  const handleMonthChange = (e) => {
    const newDate = new Date(date);
    newDate.setMonth(parseInt(e.target.value, 10));
    onMonthChange(newDate);
  };

  const handleYearChange = (e) => {
    const newDate = new Date(date);
    newDate.setFullYear(parseInt(e.target.value, 10));
    onMonthChange(newDate);
  };

  return (
    <div className="DayPicker-Caption">
      <select value={date.getMonth()} onChange={handleMonthChange}>
        {months.map((month, i) => (
          <option key={i} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select value={date.getFullYear()} onChange={handleYearChange}>
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  );
};
